/**
 * @flow
 * @relayHash f49de30d461b07ff9e6772ed71561d06
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Http3xxRedirectsTable_project$ref = any;
export type httpStatus_HttpStatusCategory_Http3xxRedirectsTable_QueryVariables = {|
  host: string
|};
export type httpStatus_HttpStatusCategory_Http3xxRedirectsTable_QueryResponse = {|
  +project: ?{|
    +$fragmentRefs: Http3xxRedirectsTable_project$ref
  |}
|};
export type httpStatus_HttpStatusCategory_Http3xxRedirectsTable_Query = {|
  variables: httpStatus_HttpStatusCategory_Http3xxRedirectsTable_QueryVariables,
  response: httpStatus_HttpStatusCategory_Http3xxRedirectsTable_QueryResponse,
|};
*/


/*
query httpStatus_HttpStatusCategory_Http3xxRedirectsTable_Query(
  $host: String!
) {
  project(host: $host) {
    ...Http3xxRedirectsTable_project
    id
  }
}

fragment Http3xxRedirectsTable_project on Project {
  host
  crawls(offset: 0, limit: 1) {
    edges {
      node {
        countTypesHttp3xxRedirects(sourceUrl: {operator: AND, values: []}, redirectUrl: {operator: AND, values: []}, codeFilters: []) {
          type
          severity
          count
        }
        countCodesHttp3xxRedirects(sourceUrl: {operator: AND, values: []}, redirectUrl: {operator: AND, values: []}, typeFilters: []) {
          code
          count
        }
        http3xxRedirects(offset: 0, limit: 20, codeFilters: [], typeFilters: [], sourceUrl: {operator: AND, values: []}, redirectUrl: {operator: AND, values: []}) {
          count
          edges {
            node {
              ...Http3xxRedirectsRow_issue
              id
            }
          }
        }
        id
      }
    }
  }
}

fragment Http3xxRedirectsRow_issue on Http3xxRedirect {
  id
  type
  severity
  code
  redirect_count
  redirect_urls
  source_url
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "host",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "host",
    "variableName": "host",
    "type": "String!"
  }
],
v2 = {
  "kind": "Literal",
  "name": "offset",
  "value": 0,
  "type": "Int"
},
v3 = {
  "kind": "Literal",
  "name": "codeFilters",
  "value": ([]/*: any*/),
  "type": "[Int]"
},
v4 = {
  "operator": "AND",
  "values": ([]/*: any*/)
},
v5 = {
  "kind": "Literal",
  "name": "redirectUrl",
  "value": v4,
  "type": "TextFilters"
},
v6 = {
  "kind": "Literal",
  "name": "sourceUrl",
  "value": v4,
  "type": "TextFilters"
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "severity",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "Literal",
  "name": "typeFilters",
  "value": ([]/*: any*/),
  "type": "[String]"
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "code",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "httpStatus_HttpStatusCategory_Http3xxRedirectsTable_Query",
  "id": null,
  "text": "query httpStatus_HttpStatusCategory_Http3xxRedirectsTable_Query(\n  $host: String!\n) {\n  project(host: $host) {\n    ...Http3xxRedirectsTable_project\n    id\n  }\n}\n\nfragment Http3xxRedirectsTable_project on Project {\n  host\n  crawls(offset: 0, limit: 1) {\n    edges {\n      node {\n        countTypesHttp3xxRedirects(sourceUrl: {operator: AND, values: []}, redirectUrl: {operator: AND, values: []}, codeFilters: []) {\n          type\n          severity\n          count\n        }\n        countCodesHttp3xxRedirects(sourceUrl: {operator: AND, values: []}, redirectUrl: {operator: AND, values: []}, typeFilters: []) {\n          code\n          count\n        }\n        http3xxRedirects(offset: 0, limit: 20, codeFilters: [], typeFilters: [], sourceUrl: {operator: AND, values: []}, redirectUrl: {operator: AND, values: []}) {\n          count\n          edges {\n            node {\n              ...Http3xxRedirectsRow_issue\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment Http3xxRedirectsRow_issue on Http3xxRedirect {\n  id\n  type\n  severity\n  code\n  redirect_count\n  redirect_urls\n  source_url\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "httpStatus_HttpStatusCategory_Http3xxRedirectsTable_Query",
    "type": "RootQuery",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "Http3xxRedirectsTable_project",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "httpStatus_HttpStatusCategory_Http3xxRedirectsTable_Query",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": v1,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "host",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "crawls",
            "storageKey": "crawls(limit:1,offset:0)",
            "args": [
              {
                "kind": "Literal",
                "name": "limit",
                "value": 1,
                "type": "Int"
              },
              v2
            ],
            "concreteType": "CrawlsConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "CrawlsEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Crawl",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countTypesHttp3xxRedirects",
                        "storageKey": "countTypesHttp3xxRedirects(codeFilters:[],redirectUrl:{\"operator\":\"AND\",\"values\":[]},sourceUrl:{\"operator\":\"AND\",\"values\":[]})",
                        "args": [
                          v3,
                          v5,
                          v6
                        ],
                        "concreteType": "CountType",
                        "plural": true,
                        "selections": [
                          v7,
                          v8,
                          v9
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "countCodesHttp3xxRedirects",
                        "storageKey": "countCodesHttp3xxRedirects(redirectUrl:{\"operator\":\"AND\",\"values\":[]},sourceUrl:{\"operator\":\"AND\",\"values\":[]},typeFilters:[])",
                        "args": [
                          v5,
                          v6,
                          v10
                        ],
                        "concreteType": "CountCode",
                        "plural": true,
                        "selections": [
                          v11,
                          v9
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "http3xxRedirects",
                        "storageKey": "http3xxRedirects(codeFilters:[],limit:20,offset:0,redirectUrl:{\"operator\":\"AND\",\"values\":[]},sourceUrl:{\"operator\":\"AND\",\"values\":[]},typeFilters:[])",
                        "args": [
                          v3,
                          {
                            "kind": "Literal",
                            "name": "limit",
                            "value": 20,
                            "type": "Int"
                          },
                          v2,
                          v5,
                          v6,
                          v10
                        ],
                        "concreteType": "Http3xxRedirectsConnection",
                        "plural": false,
                        "selections": [
                          v9,
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "edges",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Http3xxRedirectsEdge",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "node",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "Http3xxRedirect",
                                "plural": false,
                                "selections": [
                                  v12,
                                  v7,
                                  v8,
                                  v11,
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "redirect_count",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "redirect_urls",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "source_url",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      v12
                    ]
                  }
                ]
              }
            ]
          },
          v12
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '401a5ffa1dcab086b1b9f609364b3e2c';
module.exports = node;
